// src/hooks/imagePasteManager.ts
// 粘贴事件不带坐标：用一个文档级 paste 监听 + 悬停定位决定目标。
// 本模块是 UI 无关的纯插件层，toast/过滤都由注册进来的回调负责。
import { getFilesFromDataTransfer } from "../utils/imageFiles";

export interface PasteZone {
  /** 处理剪贴板文件；返回是否消费了图片（true → 调用方 preventDefault）。 */
  handleClipboardFiles: (files: File[]) => boolean;
}

let activeZone: PasteZone | null = null;
let subscriberCount = 0;

function handlePaste(e: ClipboardEvent): void {
  if (!activeZone) return;
  const files = getFilesFromDataTransfer(e.clipboardData); // 优先 files，回退 items（截图/网页图）
  const consumed = activeZone.handleClipboardFiles(files);
  if (consumed) e.preventDefault();
}

export function setActiveZone(zone: PasteZone): void {
  activeZone = zone;
}

export function clearActiveZone(zone: PasteZone): void {
  if (activeZone === zone) activeZone = null;
}

/** 引用计数地懒装/卸载唯一的 document paste 监听。返回 unsubscribe。 */
export function subscribePaste(): () => void {
  subscriberCount += 1;
  if (subscriberCount === 1) {
    document.addEventListener("paste", handlePaste);
  }
  return () => {
    subscriberCount -= 1;
    if (subscriberCount === 0) {
      document.removeEventListener("paste", handlePaste);
    }
  };
}
